import DashboardHome from "../assets/images/dashboard-unselected-new.svg";
import DashboardHomeSelected from "../assets/images/dashboard-selected-new.svg";

import ProfileIcon from "../assets/images/Profile.svg";
import ProfileIconSelected from "../assets/images/ProfileSelected.svg";

import AdvisorIcon from "../assets/images/my-advisor.svg";
import AdvisorIconSelected from "../assets/images/my-advisor-selected.svg";

import ArchiveIconUnSelected from "../assets/images/archive-unselected.svg";
import ArchiveIconSelected from "../assets/images/archive-selected.svg";

import NotificationIcon from "../assets/mobile/bell-inactive.svg";
import NotificationIconSelected from "../assets/mobile/bell-active.svg";

import UserIcon from "../assets/mobile/user-icon-inactive.svg";
import UserIconSelected from "../assets/mobile/user-icon-active.svg";

import FAQIcon from "../assets/images/faq-unselected.svg";
import FAQIconSelected from "../assets/images/faq-selected.svg";


const urlSearchParams = new URLSearchParams();

urlSearchParams.get("request_token");
urlSearchParams.get("action");
urlSearchParams.get("status");
urlSearchParams.get("type");


export const UNAUTHENTICATED_ROUTES = {
    HOME: "/",
    SIGN_IN: "/sign-in",
    SIGN_UP: "/sign-up",
    OTP_VERIFY: 'otpverify',
    ONBOARDING: 'onboarding',
    ADVISOR_SIGN_IN: "advisorlogin",
    NOTIFICATIONS: '/notifications',
};


export const AUTHENTICATED_ROUTES = {
    Dashboard_with_Params: `/dashboard` + urlSearchParams.toString(),
    DASHBOARD: "/dashboard",
    POSITION: "/position",
    HOLDINGS: "/holdings",
    ORDERS: "/orders",
    FUNDS: "/funds",
    ADVISORS: "/my-advisors",
    NOTIFIED_CALLS: "/notified-calls",
    trade: "/trade-history",
    help: "/help",
    MOBILE_NOTIFICATIONS: "/mobile-notifications",
    MY_ACCOUNT: '/mobile-my-account',
    ADVISOR_DASHBOARD: '/advisordashboard',
    ADVISOR_ARCHIVED_CALLS: '/archived-calls',
    ADVISOR_CREATE_CALL: '/tradecall',
    ADVISOR_EDIT_CALL: '/edittrade',
    ADVISOR_MY_PROFILE: '/advisormyprofile',
    ADVISOR_MOBILE_NOTIFICATIONS: '/advisor-mobile-notifications',
    ADVISOR_MY_ACCOUNT: '/advisor-mobile-my-account',
    PROFILE_SUMMARY: '/profilesummary',
    FAQS: '/faqs',
};


export const ROUTES = {
    ADVISOR: [
        {
            route: "/advisordashboard",
            label: "Dashboard",
            selectedIcon: DashboardHomeSelected,
            unSelectedIcon: DashboardHome,
        },
        {
            route: "/archived-calls",
            label: "Archived Calls",
            selectedIcon: ArchiveIconSelected,
            unSelectedIcon: ArchiveIconUnSelected,
        },
        // {
        //     route: "/mobile-notifications",
        //     label: "Notifications",
        //     selectedIcon: NotificationIconSelected,
        //     unSelectedIcon: NotificationIcon,
        // },
        {
            route: "/advisormyprofile",
            label: "Profile",
            selectedIcon: ProfileIconSelected,
            unSelectedIcon: ProfileIcon,
        },
        {
            route: "/account",
            label: "Account",
            selectedIcon: UserIconSelected,
            unSelectedIcon: UserIcon,
        },
        // {
        //     route: "/faqs",
        //     label: "FAQs",
        //     selectedIcon: FAQIconSelected,
        //     unSelectedIcon: FAQIcon,
        // }
        //   {
        //     route: "/mobile-my-account",
        //     label: "My Account",
        //     selectedIcon: PositionIconSelected,
        //     unSelectedIcon: PositionIcon,
        // },
        // {
        //     route: "/none",
        //     label: "Settings",
        //     selectedIcon: PositionIconSelected,
        //     unSelectedIcon: PositionIcon,
        // },
        // {
        //     route: "/none1",
        //     label: "FAQs",
        //     selectedIcon: PositionIconSelected,
        //     unSelectedIcon: PositionIcon,
        // },

    ],

    ADMIN: [
        {
            route: AUTHENTICATED_ROUTES.Dashboard_with_Params,
            label: "Dashboard",
            selectedIcon: DashboardHomeSelected,
            unSelectedIcon: DashboardHome,
        },
        {
            route: AUTHENTICATED_ROUTES.ADVISORS,
            label: "My Advisors",
            selectedIcon: AdvisorIconSelected,
            unSelectedIcon: AdvisorIcon,
        },
        {
            route: AUTHENTICATED_ROUTES.NOTIFIED_CALLS,
            label: "Notified Calls",
            selectedIcon: NotificationIconSelected,
            unSelectedIcon: NotificationIcon,
        },
        {
            route: "/user/account",
            label: "Profile",
            selectedIcon: ProfileIconSelected,
            unSelectedIcon: ProfileIcon,
        },
        // {
        //     route: "/faqs",
        //     label: "FAQs",
        //     selectedIcon: FAQIconSelected,
        //     unSelectedIcon: FAQIcon,
        // }
        // {
        //     route: AUTHENTICATED_ROUTES.POSITION,
        //     label: "Position",
        //     selectedIcon: PositionIconSelected,
        //     unSelectedIcon: PositionIcon,
        // },
        // {
        //     route: AUTHENTICATED_ROUTES.HOLDINGS,
        //     label: "Holdings",
        //     selectedIcon: HoldingsIconSelected,
        //     unSelectedIcon: HoldingsIcon,
        // },
        // {
        //     route: AUTHENTICATED_ROUTES.ORDERS,
        //     label: "Orders",
        //     selectedIcon: OrderIconSelected,
        //     unSelectedIcon: OrderIcon,
        // },
        // {
        //     route: AUTHENTICATED_ROUTES.FUNDS,
        //     label: "Funds",
        //     selectedIcon: FundsIconSelected,
        //     unSelectedIcon: FundsIcon,
        // },
        // {
        //     route: AUTHENTICATED_ROUTES.help,
        //     label: "Need Help",
        //     selectedIcon: "",
        //     unSelectedIcon: NeedHelpUnSelected,
        // },
    ],


    // OTHER: [
    //     {
    //         route: AUTHENTICATED_ROUTESurlSearchParams.getTING,
    //         label: "Settings",
    //         selectedIcon: Settings,
    //         unSelectedIcon: UnSelectedSettings,
    //     },
    //     {
    //         route: AUTHENTICATED_ROUTES.GET_HELP,
    //         label: "Get Help",
    //         selectedIcon: GetHelp,
    //         unSelectedIcon: UnSelectedGetHelp,
    //     },
    // ],

    AUTH: [
        { route: UNAUTHENTICATED_ROUTES.SIGN_UP, label: "Sign Up" },
        { route: UNAUTHENTICATED_ROUTES.SIGN_IN, label: "Sign In" },
    ],
};
